import React from 'react';
import LazyLoad from 'react-lazyload';
import pushGA from '../../../../services/utils/pushGA';
import './partner-card.scss';
var GA_CATEGORY = 'PORTAL PartnersMain';
var PartnerCard = function (_a) {
    var img = _a.img, title = _a.title, offer = _a.offer, link = _a.link, onClick = _a.onClick;
    var onClickHandler = function () {
        pushGA(GA_CATEGORY, 'Click_GoToMarketplace', link, {
            eventValue: 0,
            eventInteraction: 0,
            eventUX: 'TYPE:card',
        });
        onClick();
    };
    return (React.createElement("a", { href: link, onClick: onClickHandler, className: 'pc', target: '_blank' },
        React.createElement(LazyLoad, null,
            React.createElement("div", { className: 'pc__img', style: img ? { backgroundImage: "url(".concat(img, ")") } : null })),
        offer && React.createElement("p", { className: 'pc__offer', dangerouslySetInnerHTML: { __html: offer } }),
        title && React.createElement("p", { className: 'pc__title', dangerouslySetInnerHTML: { __html: title } })));
};
export default React.memo(PartnerCard);
